
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import {TemplateInterface} from './interfaces/template.interface';
import {NumberchipInterface} from './interfaces/numberchip.interface';

@Injectable({
    providedIn: 'root',
})
export class NumberchipService {
    /**
     * API URL
     * @private
     */
    private readonly apiUrl = environment.newApiUrl;

    /**
     * Constructor
     * @param http - Angular Http Client
     */
    constructor(private http: HttpClient) {
    }

    /**
     * [POST] Post a new numberchip
     * @param payload - Numberchip payload interface
     */
    public create(payload?: NumberchipInterface): Observable<any> {
        return this.http.post(`${this.apiUrl}/numberchip`, payload);
    }

    /**
     * [POST] Post a new numberchip
     * @param payload - Numberchip payload interface
     */
    public update(payload?: NumberchipInterface): Observable<any> {
        return this.http.put(`${this.apiUrl}/numberchip/${payload._id}`, payload);
    }

    /**
     * [GET] Get All numberchips by filter
     */
    public list(page, filter, size, active: number =1): Observable<any> {
        return this.http.get(`${this.apiUrl}/numberchip/findAny?search=${filter}&page=${page-1}&limit=${size}&active=${active}`);
    }

    /**
     * [GET] Get numberchips by id
     */
    public get(id): Observable<any> {
        return this.http.get(`${this.apiUrl}/numberchip/${id}`);
    }

    /**
     * [GET] Get numberchips by id
     */
    public getNumberchipByProject(customerId, projectId): Observable<any> {
        return this.http.get(`${this.apiUrl}/numberchip/project/${customerId}/${projectId}`);
    }

    /**
     * [DELETE] Disable numbechip by id
     */
    public delete(id): Observable<any> {
        return this.http.delete(`${this.apiUrl}/numberchip/${id}`);
    }
}
